//import Miles from "@lincolncenter/Miles/Miles_01.glb";
import Miles from "@lincolncenter/Miles/Miles_Comp.glb";
import MilesBuilding from "@lincolncenter/Miles/Miles-On-Building.glb";

export const paths: Map<string, string> = new Map<string, string>();

// get query string
const queryString = window.location.search;
const params = new URLSearchParams(queryString);

// get milesVariant 0 or 1
const milesVariant = params.get("milesVariant");
paths.set("miles", Miles);

console.log("milesVariant MODEL SEL", milesVariant);

if (milesVariant !== null && milesVariant === "1") {
  paths.set("miles", MilesBuilding);

}